import {
  ISearchExchangeRateReq,
  ISearchExchangeRateRes,
  ISetting,
} from '../interfaces/setting';
import * as baseAdapter from './baseAdapter';

export const querySettings = async () => {
  const ret = await baseAdapter.get<ISetting>('/setting/get');
  return ret;
};

export const editSettings = async (data: Partial<ISetting>) => {
  const ret = await baseAdapter.putForm(`/setting/update`, data);
  return ret;
};

export const queryExchangeRates = async (req: ISearchExchangeRateReq) => {
  const ret = await baseAdapter.post<ISearchExchangeRateRes>(
    `/setting/getExchangeRates`,
    req,
  );
  return ret;
};
